<template>
    <div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "App",
        data: function () {
            return {}
        },
        created() {
            let name = this.$route.name
            let params = this.$route.params
            this.$router.push({name: name, params: params})
        }
    }
</script>

<style lang="scss">

</style>

